// FitClutch — funil web — textos em inglês (idioma padrão)
export default {
  'ageSelect.titleLine1': 'Build your',
  'ageSelect.titleHighlight': 'Personalized Workout Plan',
  'ageSelect.poweredBy': 'Powered by FitClutch AI',
  'ageSelect.subtitle': 'Pick your age range to get started',
  'ageSelect.duration': '3-minute quiz',
  'ageSelect.ageLabel': 'Age: {range}',
  'ageSelect.footnote': 'By continuing, you agree to our {terms} and {privacy}.',
  'ageSelect.termsLink': 'Terms of Use',
  'ageSelect.privacyLink': 'Privacy Policy',

  'gender.title': 'What is your gender?',
  'gender.subtitle': 'We only use this to personalize your plan',
  'gender.male': 'Male',
  'gender.female': 'Female',
  'gender.other': 'Prefer not to say',

  'socialProof.genderWomen': 'women',
  'socialProof.genderMen': 'men',
  'socialProof.genderPeople': 'people',
  'socialProof.decade20': 'their 20s',
  'socialProof.decade30': 'their 30s',
  'socialProof.decade40': 'their 40s',
  'socialProof.decade50': 'their 50s and beyond',
  'socialProof.headlineBig': 'Over {users} {gender}',
  'socialProof.subcopy': 'in {decade} have already trusted FitClutch for <hl>their goals, fitness level, and available equipment</hl>. Adapting as you evolve.',
  'socialProof.subcopyNoDecade': 'have already trusted FitClutch for <hl>their goals, fitness level, and available equipment</hl>. Adapting as you evolve.',
  'socialProof.downloadsLabel': 'Downloads',
  'socialProof.cta': 'Continue',

  'goal.question': "What's your main fitness goal?",
  'goal.option_hipertrofia': 'Build muscle',
  'goal.option_emagrecer': 'Lose weight',
  'goal.option_forca': 'Get stronger',
  'goal.option_condicionamento': 'Improve overall fitness',
  'goal.feedbackLead': "We've got you:",
  'goal.feedback_hipertrofia': 'custom strength sessions with video-guided form for every rep.',
  'goal.feedback_emagrecer': 'a calorie-smart training plan that keeps your metabolism burning.',
  'goal.feedback_forca': 'progressive strength programming that builds real power, safely.',
  'goal.feedback_condicionamento': 'balanced sessions that improve endurance, mobility, and energy.',

  'bodyShape.question': 'Which best describes your body today?',
  'bodyShape.option_magro_male': 'Slim',
  'bodyShape.option_magro_female': 'Slim',
  'bodyShape.option_magro_neutral': 'Slim body',
  'bodyShape.option_cheio_male': 'Fuller',
  'bodyShape.option_cheio_female': 'Fuller',
  'bodyShape.option_cheio_neutral': 'Fuller body',
  'bodyShape.option_atletico_male': 'Athletic',
  'bodyShape.option_atletico_female': 'Athletic',
  'bodyShape.option_atletico_neutral': 'Athletic body',
  'bodyShape.option_definido_male': 'Toned',
  'bodyShape.option_definido_female': 'Toned',
  'bodyShape.option_definido_neutral': 'Toned body',
  'bodyShape.option_medio_male': 'Average',
  'bodyShape.option_medio_female': 'Average',
  'bodyShape.option_medio_neutral': 'Average build',

  'bodyGoal.question': 'What body are you aiming for?',
  'bodyGoal.option_definido_male': 'Lean and toned',
  'bodyGoal.option_definido_female': 'Lean and toned',
  'bodyGoal.option_definido_neutral': 'A lean, toned body',
  'bodyGoal.option_atletico_male': 'Athletic and muscular',
  'bodyGoal.option_atletico_female': 'Athletic and fit',
  'bodyGoal.option_atletico_neutral': 'An athletic, muscular body',
  'bodyGoal.option_magro_male': 'Slim and light',
  'bodyGoal.option_magro_female': 'Slim and light',
  'bodyGoal.option_magro_neutral': 'A slim, light body',
  'bodyGoal.option_curvilineo_male': 'Strong and solid',
  'bodyGoal.option_curvilineo_female': 'Strong and curvy',
  'bodyGoal.option_curvilineo_neutral': 'A strong, defined body',

  'lastBest.question': 'When did you last feel your best physically?',
  'lastBest.option_agora': 'Right now',
  'lastBest.option_menos_1_ano': 'Less than a year ago',
  'lastBest.option_1_3_anos': '1–3 years ago',
  'lastBest.option_mais_3_anos': 'More than 3 years ago',
  'lastBest.option_nunca': 'Never',

  'weightTrend.question': 'How does your weight typically change?',
  'weightTrend.option_estavel': 'Pretty stable',
  'weightTrend.option_varia': 'Goes up and down with my habits',
  'weightTrend.option_subindo': 'Been climbing steadily',
  'weightTrend.option_caindo': 'Been dropping steadily',
  'weightTrend.option_nao_sei': 'Not sure',

  'transformPromo.headline': 'Your goal: {target}. We\'ll show you exactly how to get there.',
  'transformPromo.subcopyLead': 'Push your limits safely. FitClutch features',
  'transformPromo.subcopyHighlight1': 'expert video demos',
  'transformPromo.subcopyMid': 'for every move to help you nail proper form and',
  'transformPromo.subcopyHighlight2': 'avoid injury',
  'transformPromo.cta': 'Continue',

  'pushUps.question': 'What\'s your max push-ups in one go?',
  'pushUps.option_nenhuma': 'None yet',
  'pushUps.option_1_5': '1-5',
  'pushUps.option_6_15': '6-15',
  'pushUps.option_16_30': '16-30',
  'pushUps.option_30_mais': '30+',

  'squats.question': 'How many squats can you power through without stopping?',
  'squats.option_nenhuma': 'None yet',
  'squats.option_1_10': '1-10',
  'squats.option_11_25': '11-25',
  'squats.option_26_50': '26-50',
  'squats.option_50_mais': '50+',

  'flexibility.question': 'How flexible are you?',
  'flexibility.option_nao_alcanco': 'Can\'t reach my toes',
  'flexibility.option_quase': 'Almost reach my toes',
  'flexibility.option_facil': 'Reach my toes with ease',
  'flexibility.option_muito_flexivel': 'Very flexible (splits, deep stretches)',
  'flexibility.option_nao_sei': 'Not sure',

  'progressPromo.headline': 'Your starting point is set. Now let\'s watch it move.',
  'progressPromo.subcopyLead': 'Every workout gets',
  'progressPromo.subcopyHighlight': 'logged automatically',
  'progressPromo.subcopyTail': '— real-time stats to keep you motivated.',
  'progressPromo.cta': 'Continue',

  'focusArea.question': 'What are your target zones?',
  'focusArea.subtitle': 'Select a specific zone or choose "Full body".',
  'focusArea.option_superior': 'Upper Body',
  'focusArea.option_core': 'Core / Abs',
  'focusArea.option_inferior': 'Lower Body',
  'focusArea.option_corpo_inteiro': 'Full body',
  'focusArea.cta': 'Continue',

  'injuries.question': 'Any areas that need extra care?',
  'injuries.subtitle': "We'll adjust your exercises to protect those regions.",
  'injuries.option_ombros': 'Shoulders',
  'injuries.option_joelhos': 'Knees',
  'injuries.option_costas': 'Back',
  'injuries.option_nenhuma': 'None of these',
  'injuries.disclaimer': "Preventive adjustments — not a substitute for medical advice.",
  'injuries.cta': 'Continue',

  'workoutDuration.question': "What's your ideal workout length?",
  'workoutDuration.option_rapido': 'Quick',
  'workoutDuration.option_rapido_subtitle': '3 exercises',
  'workoutDuration.option_rapido_badge': 'Up to 20 min',
  'workoutDuration.option_curto': 'Short',
  'workoutDuration.option_curto_subtitle': '4-6 exercises',
  'workoutDuration.option_curto_badge': '20-40 min',
  'workoutDuration.option_medio': 'Medium',
  'workoutDuration.option_medio_subtitle': '5-7 exercises',
  'workoutDuration.option_medio_badge': '40-60 min',
  'workoutDuration.option_longo': 'Long',
  'workoutDuration.option_longo_subtitle': '8-10 exercises',
  'workoutDuration.option_longo_badge': '60+ min',

  'trainingSummaryPromo.headline': '{days}, {duration} sessions — coming right up.',
  'trainingSummaryPromo.subcopyLead': 'Pulled straight from our',
  'trainingSummaryPromo.subcopyHighlight': 'library of workouts',
  'trainingSummaryPromo.subcopyTail': ", so there's always one ready for you.",
  'trainingSummaryPromo.cta': 'Continue',
  'trainingSummaryPromo.days_2': '1-2x a week',
  'trainingSummaryPromo.days_4': '3-4x a week',
  'trainingSummaryPromo.days_6': '5-6x a week',
  'trainingSummaryPromo.days_7': 'Every day',

  'workSchedule.question': "What's your work schedule like?",
  'workSchedule.option_fixo': '9 to 5',
  'workSchedule.option_noturno': 'Night shifts',
  'workSchedule.option_flexivel': 'Flexible hours',
  'workSchedule.option_parado': "I'm not working",

  'dailyActivity.question': 'How active is your day-to-day?',
  'dailyActivity.option_sentado': 'Mostly sitting',
  'dailyActivity.option_ativo': 'Mostly standing or moving',
  'dailyActivity.option_misto': 'A mix of both',
  'dailyActivity.option_nao_sei': "I'm not sure",

  'sleepHours.question': 'How much sleep do you usually get?',
  'sleepHours.option_menos_5': 'Less than 5 hours',
  'sleepHours.option_5_6': '5-6 hours',
  'sleepHours.option_7_8': '7-8 hours',
  'sleepHours.option_mais_8': 'More than 8 hours',

  'waterIntake.question': 'How many glasses of water do you drink a day?',
  'waterIntake.subtitle': 'Tap the number closest to your routine.',
  'waterIntake.cta': 'Continue',

  'profileSummary.headline': "Here's your profile",
  'profileSummary.imcLabel': 'BMI - {imc}',
  'profileSummary.imcAbaixo': 'Below',
  'profileSummary.imcNormal': 'Normal',
  'profileSummary.imcAcima': 'Above',
  'profileSummary.imcObeso': 'Obese',
  'profileSummary.bodyTypeLabel': 'Body type',
  'profileSummary.bodyType_ectomorfo': 'Ectomorph',
  'profileSummary.bodyType_mesomorfo': 'Mesomorph',
  'profileSummary.bodyType_endomorfo': 'Endomorph',
  'profileSummary.lifestyleLabel': 'Lifestyle',
  'profileSummary.lifestyle_sedentario': 'Sedentary',
  'profileSummary.lifestyle_ativo': 'Active',
  'profileSummary.lifestyle_equilibrado': 'Balanced',
  'profileSummary.conditioningLabel': 'Fitness level',
  'profileSummary.conditioning_iniciante': 'Basic',
  'profileSummary.conditioning_intermediario': 'Intermediate',
  'profileSummary.conditioning_avancado': 'Advanced',
  'profileSummary.conditioning_especialista': 'Expert',
  'profileSummary.metabolismLabel': 'Metabolism',
  'profileSummary.metabolism_lento': 'Slow, gains weight easily',
  'profileSummary.metabolism_acelerado': 'Fast, loses weight easily',
  'profileSummary.metabolism_equilibrado': 'Balanced',
  'profileSummary.metabolism_variavel': 'Variable, depends on habits',
  'profileSummary.cta': 'Continue',

  'barriers.question': 'What stopped you from getting fit before?',
  'barriers.option_motivacao': 'Low motivation',
  'barriers.option_sem_plano': 'No structured plan',
  'barriers.option_tempo': 'Lack of time',
  'barriers.option_lesoes': 'Physical injuries',
  'barriers.option_outro': 'Other reasons',

  'consistencyChart.headline': 'FitClutch helps you stay consistent!',
  'consistencyChart.subcopyLead': 'Your personalized plan has everything you need to',
  'consistencyChart.subcopyHighlight1': 'keep your motivation high',
  'consistencyChart.subcopyMid': 'and',
  'consistencyChart.subcopyHighlight2': 'reach the body you want',
  'consistencyChart.chartTitle': 'Your progress',
  'consistencyChart.nowLabel': 'Now',
  'consistencyChart.withLabel': 'With FitClutch',
  'consistencyChart.withoutLabel': 'Without FitClutch',
  'consistencyChart.disclaimer': 'Disclaimer: examples are illustrative. Staying consistent with workouts and nutrition is what truly drives results.',
  'consistencyChart.cta': 'Continue',

  'progressLoader.headline': 'Creating your Personal Workout Plan',
  'progressLoader.item_bodyType': 'Adapting to your body type and routine',
  'progressLoader.item_fitnessLevel': 'Evaluating your fitness level',
  'progressLoader.item_plan': 'Building your personalized plan',
  'progressLoader.testimonial1_title': 'Changed my routine',
  'progressLoader.testimonial1_body': 'Finally a plan that actually fits my week. Easy to follow and the workouts make sense.',
  'progressLoader.testimonial1_author': 'Renata A.',
  'progressLoader.testimonial2_title': 'Real results',
  'progressLoader.testimonial2_body': 'In just a few weeks I already felt the difference in energy and strength. The plan adjusts to me.',
  'progressLoader.testimonial2_author': 'Juliana M.',
  'progressLoader.testimonial3_title': 'A routine I actually stick to',
  'progressLoader.testimonial3_body': "I could never keep a routine until I started using FitClutch. Now it's just part of my day.",
  'progressLoader.testimonial3_author': 'Carla S.',
  'progressLoader.testimonial4_title': 'So worth it',
  'progressLoader.testimonial4_body': 'Simple, straight to the point, and built around my body and my schedule.',
  'progressLoader.testimonial4_author': 'Fernanda O.',

  'emailCapture.headlineLead': 'Enter your e-mail to get your',
  'emailCapture.headlineHighlight': 'Personalized Workout Plan',
  'emailCapture.placeholder': 'youremail@example.com',
  'emailCapture.cta': 'Continue',
  'emailCapture.privacyLead': 'We respect your privacy and protect your personal data, in accordance with our',
  'emailCapture.privacyLink': 'Privacy Policy',

  // ------------------------------------------------------------------------
  // Paywall internacional (todos os mercados exceto BR) — tela longa de
  // rolagem única, estrutura inspirada na página de paywall do Befit
  // (pesquisa-concorrentes.md), com texto e visual 100% próprios da
  // FitClutch. Hoje só existe em inglês — as outras 6 línguas caem no
  // fallback automático do t() até serem traduzidas.
  'paywallIntl.offerReserved': 'Offer reserved for:',
  'paywallIntl.getPlan': 'Get my plan',
  'paywallIntl.planReadyLead': 'Your',
  'paywallIntl.planReadyHighlight': 'Personalized Workout Plan',
  'paywallIntl.planReadyTail': 'is ready',
  'paywallIntl.dayLabel': 'Day {n}',
  'paywallIntl.statWorkouts': 'Workouts/week',
  'paywallIntl.statDuration': 'Minutes',
  'paywallIntl.statCalories': 'Calories',
  'paywallIntl.muscle_chest': 'Chest',
  'paywallIntl.muscle_back': 'Back',
  'paywallIntl.muscle_legs': 'Legs',
  'paywallIntl.muscle_shoulders': 'Shoulders',
  'paywallIntl.muscle_triceps': 'Triceps',
  'paywallIntl.muscle_biceps': 'Biceps',
  'paywallIntl.muscle_abs': 'Abs',
  'paywallIntl.muscle_glutes': 'Glutes',
  'paywallIntl.muscle_forearms': 'Forearms',
  'paywallIntl.weeklyPlanName': 'Weekly Plan',
  'paywallIntl.perWeek': 'per week',
  'paywallIntl.benefitsTitle': 'What you get with',
  'paywallIntl.benefit1': 'Personalized plan for your goal',
  'paywallIntl.benefit2': 'Exercise library with video demonstrations',
  'paywallIntl.benefit3': 'Log sets, reps and weights',
  'paywallIntl.benefit4': 'Track your evolution',
  'paywallIntl.benefit5': 'Adjustments as your progress grows',
  'paywallIntl.resultsTitle': 'Real People. Real Progress.',
  'paywallIntl.resultsSubtitle': 'See how people are training smarter and building consistency with FitClutch.',
  'paywallIntl.testimonial1_category': 'Weight Loss',
  'paywallIntl.testimonial1_title': 'Marina T. — Took back control at 41',
  'paywallIntl.testimonial1_result': 'Result: -12 lbs',
  'paywallIntl.testimonial1_quote': 'I finally managed to follow a plan without switching workouts every week.',
  'paywallIntl.testimonial2_category': 'Muscle Gain',
  'paywallIntl.testimonial2_title': 'Lucas R. — Rebuilt his strength at 34',
  'paywallIntl.testimonial2_result': 'Result: +18% strength',
  'paywallIntl.testimonial2_quote': 'I started tracking my progression and finally began to see real improvement.',
  'paywallIntl.testimonial3_category': 'Consistency',
  'paywallIntl.testimonial3_title': 'Sofia M. — Finally stuck with it',
  'paywallIntl.testimonial3_result': 'Result: 4 months straight',
  'paywallIntl.testimonial3_quote': 'The plan fits my actual schedule, so I stopped skipping workouts.',
  'paywallIntl.testimonial4_category': 'Beginner',
  'paywallIntl.testimonial4_title': 'Leo M. — Started from zero at 28',
  'paywallIntl.testimonial4_result': 'Result: 3 workouts per week',
  'paywallIntl.testimonial4_quote': 'I never knew where to start. The plan showed me exactly what to do each day.',
  'paywallIntl.faqTitle': 'People Often Ask',
  'paywallIntl.faq1_q': 'How do I access FitClutch after subscribing?',
  'paywallIntl.faq1_a': 'Right away — your plan unlocks the moment your payment is confirmed, no waiting.',
  'paywallIntl.faq2_q': 'Do I need gym equipment?',
  'paywallIntl.faq2_a': 'No. Your plan is built from your own answers, including whether you train at home, outdoors or at a gym.',
  'paywallIntl.faq3_q': 'Is FitClutch suitable for beginners?',
  'paywallIntl.faq3_a': 'Yes. The plan adapts to your current fitness level, from complete beginner to advanced.',
  'paywallIntl.faq4_q': 'How do I cancel?',
  'paywallIntl.faq4_a': 'You can cancel anytime from your account page, before the next renewal. No phone calls, no retention tricks.',
  'paywallIntl.chooseTitle': 'Choose your plan',
  'paywallIntl.couponLabel': 'FITCLUTCH50',
  'paywallIntl.couponBadge': '50% OFF',
  'paywallIntl.couponActiveFor': 'Promo code active for:',
  'paywallIntl.perDay': 'per day',
  'paywallIntl.cta': 'Unlock my plan',
  'paywallIntl.billingDisclosure': 'Without cancellation, before the selected intro plan ends, I accept that FitClutch will automatically charge {precoCheio} every {periodo} until I cancel. Cancel anytime from your account page.',
  'paywallIntl.secureCheckout': 'Guaranteed Safe Checkout',
  'paywallIntl.guaranteeTitle': '30-day guarantee',
  'paywallIntl.guaranteeBody': 'Try FitClutch with peace of mind. If your purchase is eligible, you can request a refund under the terms of our guarantee.',

  // ---- Refatoração da paywall (05/10/2026): prévia real do plano + conversão
  'paywallIntl.myPlan': 'My Plan',
  'paywallIntl.dayTab': 'DAY {n}',
  'paywallIntl.workoutSettings': 'DAY {n} · WORKOUT SETTINGS',
  'paywallIntl.chipMinutes': '{n} min',
  'paywallIntl.chipMuscles': '{n} muscles',
  'paywallIntl.goal_condicionamento': 'Conditioning',
  'paywallIntl.goal_forca': 'Strength',
  'paywallIntl.goal_emagrecer': 'Weight loss',
  'paywallIntl.goal_hipertrofia': 'Muscle gain',
  'paywallIntl.targetMuscles': 'TARGET MUSCLES',
  'paywallIntl.exercisesCount': '{n} EXERCISES',
  'paywallIntl.edit': 'Edit',
  'paywallIntl.setsReps': '{sets} sets • {reps} reps',
  'paywallIntl.setsOnly': '{sets} sets',
  'paywallIntl.statLineWorkouts': 'workouts/week',
  'paywallIntl.statLineMinutes': 'per workout',
  'paywallIntl.statLineKcal': 'est. kcal',
  'paywallIntl.unlockTitle': 'Your full plan is ready.',
  'paywallIntl.unlockSub': 'Unlock every day, every exercise and your progress tracking.',
  'paywallIntl.unlockCta': 'UNLOCK MY PLAN',
  'paywallIntl.benefit6': 'Home or gym workouts, your choice',
  'paywallIntl.progressTitle': 'More than a list of exercises',
  'paywallIntl.progressSub': 'You unlock a system to track every workout and your evolution.',
  'paywallIntl.progressToday': 'YOUR PLAN TODAY',
  'paywallIntl.progressNext': 'YOUR PROGRESS',
  'paywallIntl.progressNow': 'Consistency today',
  'paywallIntl.progressWith': 'With FitClutch',
  'paywallIntl.progressNote': 'Projection based on your answers.',
  'paywallIntl.track1': 'Workout history',
  'paywallIntl.track2': 'Load evolution',
  'paywallIntl.track3': 'Muscle balance',
  'paywallIntl.track4': 'Fitness Score',
  'paywallIntl.convertTitle': 'Start your personalized plan today',
  'paywallIntl.convertSub': 'Pick how you want to start. Cancel anytime.',
  'paywallIntl.guaranteeNote': 'Try FitClutch with peace of mind. Check the guarantee terms.',
  'paywallIntl.stickyText': 'Your plan is ready',
  'paywallIntl.stickyCta': 'Unlock',
  'paywallIntl.plan_week': 'Weekly Plan',
  'paywallIntl.plan_month': 'Monthly Plan',
  'paywallIntl.plan_year': 'Annual Plan',
  'paywallIntl.badgePopular': 'MOST POPULAR',
  'paywallIntl.badgeBest': 'BEST VALUE',
  'paywallIntl.badgeOff': '{pct}% OFF',
  'paywallIntl.perWeekShort': '/ week',
  'paywallIntl.perMonthShort': '/ month',
  'paywallIntl.perYearShort': '/ year',
  'paywallIntl.perDayEq': '{price} per day',
  'paywallIntl.renewal': 'You pay {promo} today. After that, FitClutch renews automatically at {full} per {period} until you cancel. Cancel anytime from your account page, before the next renewal.',
  'paywallIntl.renewalNoPromo': 'FitClutch renews automatically at {full} per {period} until you cancel. Cancel anytime from your account page, before the next renewal.',
  'paywallIntl.period_week': 'week',
  'paywallIntl.period_month': 'month',
  'paywallIntl.period_year': 'year',
  'paywallIntl.benefitsEmoji1': 'Personalized plan built from your answers',
  'paywallIntl.faq5_q': 'Is there a guarantee?',
  'paywallIntl.faq5_a': 'Yes. FitClutch has a 30-day guarantee. If your purchase is eligible, you can request a refund under the terms of our guarantee.',
  'paywallIntl.faq6_q': 'Can I train at home?',
  'paywallIntl.faq6_a': 'Yes. Your plan is built from your answers, including whether you train at home or at a gym.',
  'paywallIntl.placeholderTag': 'Example',
  'paywallIntl.resultsDisclaimer': 'Illustrative examples. Individual results vary.',
  'paywallIntl.plansLoading': 'Loading plans…',
  'paywallIntl.plansError': 'We could not load the plans right now.',
  'paywallIntl.plansRetry': 'Try again',
  'paywallIntl.guaranteeSectionTitle': '30-day guarantee',
  'paywallIntl.guaranteeSectionBody': 'Try FitClutch with peace of mind. If your purchase is eligible, you can request a refund under the terms of our guarantee.',
  'paywallIntl.secureTitle': '100% Secure Checkout',
  'paywallIntl.secureNote': 'Payment processed by Stripe. We never see your card details.',
  'paywallIntl.finalTitle': 'Your plan is waiting',
  'paywallIntl.finalSub': 'Start today and train with a plan built for you.',
};
